// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apPSjaXKFjoMMwHzKV0A {
  min-width: 1240px;
}
.apPSjaXKFjoMMwHzKV0A .l1aZfW6yv9TE6kS5aJqG {
  padding: 6px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.apPSjaXKFjoMMwHzKV0A .aOCfBU5Ys6gU6hweDsT8 {
  position: relative;
  padding-left: 16px;
}
.apPSjaXKFjoMMwHzKV0A .aOCfBU5Ys6gU6hweDsT8 .anticon {
  position: absolute;
  left: 0px;
  top: 4px;
  cursor: pointer;
  color: #999;
}
.apPSjaXKFjoMMwHzKV0A .aQnr2PgKusZCaPN6kLa6 {
  margin-left: 16px;
}
.apPSjaXKFjoMMwHzKV0A .BVJsqO3uPVl4TzoGS7U6 {
  margin-left: 32px;
}
.apPSjaXKFjoMMwHzKV0A ._08qIyZthYoSceIv0jYDQ {
  font-weight: 500;
  color: #7d8592;
  line-height: 16px;
  background: #f5f6f8;
  border-radius: 4px;
  padding: 4px 8px;
}
.apPSjaXKFjoMMwHzKV0A .drop-over-disable {
  background: #fff2f0;
}
.apPSjaXKFjoMMwHzKV0A .drop-over-able {
  background: #f6ffed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Task/List/index.module.less"],"names":[],"mappings":"AACA;EACE,iBAAA;AAAF;AADA;EAII,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;AAPA;EAUI,kBAAA;EACA,kBAAA;AAAJ;AAXA;EAcQ,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,WAAA;AAAR;AAlBA;EAuBI,iBAAA;AAFJ;AArBA;EA0BI,iBAAA;AAFJ;AAxBA;EA8BI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAHJ;AAhCA;EAwCM,mBAAA;AALN;AAnCA;EA2CM,mBAAA;AALN","sourcesContent":["\n.container {\n  min-width: 1240px;\n\n  .filter {\n    padding: 6px 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .taskName {\n    position: relative;\n    padding-left: 16px;\n    :global {\n      .anticon {\n        position: absolute;\n        left: 0px;\n        top: 4px;\n        cursor: pointer;\n        color: #999;\n      }\n    }\n  }\n  .nameLevel-2 {\n    margin-left: 16px;\n  }\n  .nameLevel-3 {\n    margin-left: 32px;\n  }\n\n  .taskNum {\n    font-weight: 500;\n    color: #7d8592;\n    line-height: 16px;\n    background: #f5f6f8;\n    border-radius: 4px;\n    padding: 4px 8px;\n  }\n\n  :global {\n    .drop-over-disable {\n      background: #fff2f0;\n    }\n    .drop-over-able {\n      background: #f6ffed;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `apPSjaXKFjoMMwHzKV0A`,
	"filter": `l1aZfW6yv9TE6kS5aJqG`,
	"taskName": `aOCfBU5Ys6gU6hweDsT8`,
	"nameLevel-2": `aQnr2PgKusZCaPN6kLa6`,
	"nameLevel-3": `BVJsqO3uPVl4TzoGS7U6`,
	"taskNum": `_08qIyZthYoSceIv0jYDQ`
};
export default ___CSS_LOADER_EXPORT___;
